import 'next/stylesheets/components/page/page-loading';

const templates = {
  default: '<span class="twr twr-misc-loading twr-spin"></span>',
  todos: '<span class="twr twr-misc-loading twr-spin"></span>',
};

function getLoadingElement(url) {
  const matches = url.match(/teams.*\/([a-z_]+)\//);
  const type = matches ? matches[1] : 'default';

  const element = document.createElement('div');
  element.classList.add('page-loading');
  element.tabIndex = 0;
  element.innerHTML = templates[type] || templates.default;
  return element;
}

export default getLoadingElement;
